import "bootstrap/dist/css/bootstrap.min.css";
import { FaLocationArrow, FaTimes } from "react-icons/fa";
import {
  useJsApiLoader,
  GoogleMap,
  Marker,
  Autocomplete,
  DirectionsRenderer,
} from "@react-google-maps/api";
import { useRef, useState } from "react";
import "../css/NewMap.css";
import { Button, Form, Col } from "react-bootstrap";
import { useContext } from "react";
import { ThemeContext } from "../context/ThemeContext";
import { Link } from "react-router-dom";

const center = { lat: 6.84127, lng: 79.90165 };

function NewMap() {
  const {
    setglobaldistance,
    setglobalduration,
    globaldistance,
    globalduration,
  } = useContext(ThemeContext);

  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
    libraries: ["places"],
  });

  const [map, setMap] = useState(/** @type google.maps.Map */ (null));
  const [directionsResponse, setDirectionsResponse] = useState(null);
  const [distance, setDistance] = useState("");
  const [duration, setDuration] = useState("");

  /** @type React.MutableRefObject<HTMLInputElement> */
  const originRef = useRef();
  /** @type React.MutableRefObject<HTMLInputElement> */
  const destiantionRef = useRef();

  if (!isLoaded) {
    return;
  }

  async function calculateRoute() {
    if (originRef.current.value === "" || destiantionRef.current.value === "") {
      return;
    }
    // eslint-disable-next-line no-undef
    const directionsService = new google.maps.DirectionsService();
    const results = await directionsService.route({
      origin: originRef.current.value,
      destination: destiantionRef.current.value,
      // eslint-disable-next-line no-undef
      travelMode: google.maps.TravelMode.DRIVING,
    });
    setDirectionsResponse(results);
    setDistance(results.routes[0].legs[0].distance.text);
    setDuration(results.routes[0].legs[0].duration.text);

    setglobaldistance(results.routes[0].legs[0].distance.text);
    setglobalduration(results.routes[0].legs[0].duration.text);
    console.log("distance" + globaldistance + "duration" + globalduration);
  }

  function clearRoute() {
    setDirectionsResponse(null);
    setDistance("");
    setDuration("");
    originRef.current.value = "";
    destiantionRef.current.value = "";
  }

  return (
    <div>
      <div className="whole">
        <div className="map-display">
          {/* Google Map Box */}
          <GoogleMap
            center={center}
            zoom={15}
            mapContainerStyle={{ width: "100%", height: "100%" }}
            onLoad={(map) => setMap(map)}
          >
            <Marker position={center} />

            {directionsResponse && (
              <DirectionsRenderer directions={directionsResponse} />
            )}
          </GoogleMap>
        </div>

        <div className="details-form-box">
          <div className="row-1-map row">
            <div className="col-sm-4">
              <Autocomplete>
                <Form.Control
                  type="text"
                  placeholder="Origin"
                  ref={originRef}
                />
              </Autocomplete>
            </div>
            <div className="col-sm-4">
              <Autocomplete>
                <Form.Control
                  type="text"
                  placeholder="Destination"
                  ref={destiantionRef}
                />
              </Autocomplete>
            </div>

            <div className="col-sm-4">
              <Button
                className="calculate-btn-edit "
                type="submit"
                onClick={calculateRoute}
              >
                Calculate Route
              </Button>
              <Button className="arrow-btns" onClick={clearRoute}>
                <FaTimes />
              </Button>
            </div>
          </div>

          <div className="row-2-map row">
            <div className="col-sm-4">
              <span>Distance: {distance} </span>
            </div>
            <div className="col-sm-4">
              <span>Duration: {duration} </span>
            </div>
            <div className="col-sm-4">
              <Button
                className="arrow-btns"
                onClick={() => {
                  map.panTo(center);
                  map.setZoom(15);
                }}
              >
                <FaLocationArrow />
              </Button>


              {/* <Col>
                  <Link to="/DistributionForm">
                    <button
                      type="submit"
                      className="btn btn-primary btn-padding distribution-btn"
                    >
                      Form
                    </button>
                  </Link>
                </Col> */}




            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default NewMap;
